import React, { Component } from 'react';
import '../css/Register.css';
import Vas from '../Vas';
import { ExtendedButton } from 'component-lib';

var moment = require('moment');
moment().format();

class RegisterQuestion  extends Component {
    
    constructor(props)
    {
        super(props);
        this.state = {};
    }
    
    
    
    render()
    {
        return (
          <div className={"RegisterContainer"} style={{width:'700px'}}>
            <div 
              className={"registerform"} 
              style={{ textAlign:'left', width:'700px' }}>
              <div>
                <h2>{Vas.Resources.Titles["Register"]}</h2>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        {Vas.Resources.Labels["RegisterText"]}
                        <br/> <br/>
                        {Vas.Resources.Labels["LinkLoginFemininum"]} 
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ExtendedButton
                          OnClick={()=>{Vas.GetView('Register',null,false);}}
                          Id={'RegisterNewCustomer'}
                          Width={375}
                          Text={Vas.Resources.Labels["RegisterNewCustomer"]}
                          Usable={true}
                           />
                        
                        <br /><br />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        {Vas.Resources.Labels["Register2Text"]}
                        <br/><br/>
                        {Vas.Resources.Labels["LinkLoginFemininum"]}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ExtendedButton
                          OnClick={()=>{Vas.GetView('RegisterExistingCustomer',null,false);}}
                          Id={'RegisterExistingCustomer'}
                          Width={375}
                          Text={Vas.Resources.Labels["RegisterExistingCustomer"]}
                          Usable={true}
                           />
                        
                        <br /><br />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        );
    }
}
export default RegisterQuestion;
